
class UserGuides extends HTMLElement{
    constructor(){
      super();
      this.pointTarget = this.dataset.target;
      this.collections = this.querySelectorAll(".guide__collection-inner");

      this.popup = this.querySelector(".guide__popup");
      this.loading = this.popup.querySelector(".guide__popup-loading-container");
      this.content_wrapper = this.popup.querySelector(".guide__popup-content");
      this.not_found = this.content_wrapper.querySelector(".guide__popup-notfound");

      this.products_list = this.querySelector(".guide__popup-products--list");

      Array.from(this.collections).forEach(function(collection){
        collection.addEventListener("click", this.showGuideForCollection.bind(this));
      }, this);

      this.closePopupBtn = this.querySelector(".guide__popup-close");
      this.closePopupBtn.addEventListener("click", this.closePopup.bind(this))
    }

    showGuideForCollection(e) {
      e.preventDefault();
      
      let current_products = this.getElementsByClassName("guide__popup-product");
      if(current_products.length > 0) {
        Array.from(current_products).forEach(function(current_product){
          current_product.remove();
        });
      }

      let collection_id = e.currentTarget.getAttribute("data-collection");
      
      this.products = collectionsData[collection_id];

      let index = this.products.indexOf("");
      if (index > -1) { 
        this.products.splice(index, 1); 
      }

      

      if (e.currentTarget.classList.contains("active")) {
        e.currentTarget.classList.remove("active");
        this.closePopupBtn.click();
      }else {
        Array.from(this.collections).forEach(function(collection){
          if (collection.classList.contains("active")) {
            collection.classList.remove("active");
          }
        }, this);
        e.currentTarget.classList.add("active");

        if(this.popup.classList.contains("hide-popup")) {
          this.popup.classList.remove("hide-popup");
        }
        
        this.guideHandle();
      } 
      
    }

    guideHandle() {
      var that = this;
      let products_html = '';
      setTimeout(function() {
        for(let i = 0; i < that.products.length; i++) {
          let product = that.getProductItemHtml();
          products_html += product;
        }
        that.products_list.innerHTML = products_html;
        let popup_title_height = that.getElementsByClassName('guide__popup-title')[0].offsetHeight + 40;
        let popup_content = that.getElementsByClassName('guide__popup-content')[0];
        let popup_content_height = popup_content.offsetHeight;
        let popup_height = popup_title_height + popup_content_height;
        console.log(popup_title_height);
        console.log(popup_content_height);
        console.log(popup_height);
        that.popup.style.height = popup_height + 'px';
        if(that.products.length < 1) {
          that.not_found.style.display = "block";
        }else{
          that.not_found.style.display = "none";
          that.loading.style.opacity = '1';
          that.loading.style.visibility = 'visible';
        }

        that.getGuide();
                
      }, 500);
    }
    getGuide() {
      let productLayout = this.getElementsByClassName("guide__popup-product");

      let count_product_show = 0;
      for(let i = 0; i < this.products.length; i++) {
        let product_handle = this.products[i];
        fetch(window.location.origin + '/products/' + product_handle + '.json')
        .then((response) => response.json())
        .then((data) => {
          let productData = data['product'];
          let image = productData['image']['src'];
          let title = productData['title'];
          let link = 'products/' + productData['handle'] + '#' + this.pointTarget;

          let image_html = productLayout[i].querySelector(".guide__popup-product-image");
          let title_html = productLayout[i].querySelector(".guide__popup-product-title");
          let link_html = productLayout[i].querySelector(".guide__popup-product-link");

          image_html.innerHTML = "<img src='" + image + "'>";
          title_html.innerText = title;
          link_html.setAttribute("href", window.location.origin + '/' + link);

          if(!productLayout[i].classList.contains("success")) {
            productLayout[i].classList.add("success");
          }
          count_product_show++;
          if(count_product_show == this.products.length) {
            this.loading.style.opacity = "0";
            this.loading.style.visibility = "hidden";
          }
        });        
      }
    }
    getProductItemHtml() {
      let html = "";
      html += "<div class='guide__popup-product'>";
        html += "<a href='' class='guide__popup-product-link' target='__blank'>";
          html += "<div class='guide__popup-product-image'>";
          html += "</div>";
  
          html += "<div class='guide__popup-product-title'></div>";
        html += "</a>";
      html += "</div>";
  
      return html;
    }
    closePopup(e) {
      e.preventDefault();

      if(!this.popup.classList.contains("hide-popup")) {
        this.popup.classList.add("hide-popup");
      }

      Array.from(this.collections).forEach(function(collection){
        if (collection.classList.contains("active")) {
          collection.classList.remove("active");
        }
      }, this);
    }
  }
  
  customElements.define("user-guides", UserGuides);
  